import { defineStore } from 'pinia'
import { ref } from 'vue'

export type Breadcrumb = {
  label: string
  path?: string
}
export const useLayoutStore = defineStore('layout-store', () => {
  const breadcrumb = ref<Breadcrumb[]>([])
  function set_breadcrumb(data: Breadcrumb[]) {
    breadcrumb.value = data
  }
  return { breadcrumb, set_breadcrumb }
})
